import { useMutation } from "react-query";
import { getTimeRangeSettlement } from "api/SettlementApi"
import { Skeleton } from "antd"
import { useEffect, useState } from "react";
import { Column } from '@ant-design/plots';
export default function SettlementHistogram(props) {
  const [data, setData] = useState([])
  const { mutate: settlementDashboard, isLoading: postLoading } = useMutation(
    () => getTimeRangeSettlement(props.fromdate, props.todate),
    {
      onSuccess: (data) => {
        if (data.code == 200) {
          setData(data.payload)
        }
        // Success actions
      },
      onError: (error) => {
        // Error actions
        console.log("error", error)
      },
    }
  );

  if (postLoading) {
    <Skeleton active />
  }

  useEffect(() => {
    settlementDashboard()
  }, [])
  useEffect(() => {
    settlementDashboard()
  }, [props])

  const config = {
    data: data,
    isGroup: true,
    xField: 'date',
    yField: 'value',
    seriesField: 'type',
    label: {
      position: 'middle',
      layout: [
        {
          type: 'interval-adjust-position',
        },
        {
          type: 'interval-hide-overlap',
        },
        {
          type: 'adjust-color',
        },
      ],
    },
  };
  return <Column {...config} />;
}